/**
 * File: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend/src/app/modules/catalog-cloud/resolvers/catalog.resolver copy.ts
 * Project: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend
 * Created Date: Tuesday, December 17th 2024, 1:29:33 pm
 * Author: Tomás
 * -----
 * Last Modified:  Tuesday, 17th December 2024 1:30:18 pm
 * Modified By: Tomás (tomas@cege.es>)
 * -----
 * Copyright (c) 2024 Nousmedis, CeGe
 * ------------------------------------
 */


/*
 * File: fascicle.resolver.ts                                                  *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 9th March 2022 14:41:17                            *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 2nd December 2022 14:22:16                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */



import { inject, Injectable } from '@angular/core';
import {
  ResolveFn
} from '@angular/router';
import { CatalogService } from '../services/catalog.service';

export const CatalogNewResolver: ResolveFn<any> = async (route, state) => {
  return inject(CatalogService).getBreadCrumbNewCatalog();
}
